import { UncontrolledPopover } from "./UncontrolledPopover"

export default UncontrolledPopover
